import {useSyncExternalStore} from 'react'
import {notifyStorageKeyChanged, subscribeToStorageKey} from './same-tab-storage'
import {AGENT_TASKS_REASONING_EFFORT_KEY} from './storage-keys'
import {isReasoningEffort, type ReasoningEffort} from '@github-ui/copilot-shared-ui/utils/reasoning-effort'

function subscribe(callback: () => void) {
  return subscribeToStorageKey(AGENT_TASKS_REASONING_EFFORT_KEY, callback)
}

function getSnapshot() {
  try {
    const stored = localStorage.getItem(AGENT_TASKS_REASONING_EFFORT_KEY)
    return isReasoningEffort(stored) ? stored : undefined
  } catch {
    return undefined
  }
}

function getServerSnapshot() {
  return undefined
}

function setLatestReasoningEffort(newValue: ReasoningEffort | undefined) {
  try {
    if (newValue === undefined) {
      localStorage.removeItem(AGENT_TASKS_REASONING_EFFORT_KEY)
    } else {
      localStorage.setItem(AGENT_TASKS_REASONING_EFFORT_KEY, newValue)
    }
    notifyStorageKeyChanged(AGENT_TASKS_REASONING_EFFORT_KEY)
  } catch {
    // localStorage not available
  }
}

export function useLatestReasoningEffort(): [
  ReasoningEffort | undefined,
  (value: ReasoningEffort | undefined) => void,
] {
  const value = useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot)

  return [value, setLatestReasoningEffort]
}
